export interface EntityReltnDto {
  id: number;
  startEntityId: number;
  startEntityName: string;
  endEntityId: number;
  endEntityName: string;
  ownershipPercent: number;
  tierLevel: number;
  relationshipDirection: string;
}

export interface TierNodeDto {
  entityId: number;
  entityName: string;
  ownershipPercent: number;
  tierLevel: number;
  children: TierNodeDto[];
}

export interface CreateRelationshipDto {
  startEntityId: number;
  endEntityId: number;
  ownershipPercent: number;
  relationshipDirection: string;
  tierLevel?: number;
}

export interface UpdateRelationshipDto {
  ownershipPercent: number;
  relationshipDirection: string;
}

// ── Partner Roster (Session P7) ─────────────────────────────────────────────

export interface PartnerOfPartnershipDto {
  relationshipId: number;
  partnerId: number;
  partnerName: string;
  partnerType: string;
  ownershipPercent: number | null;
  interestClass: string | null;
  entryDate: string | null;
  exitDate: string | null;
  isActive: boolean;
}

export interface BulkAddPartnerItemDto {
  partnerId: number;
  ownershipPercent: number;
  interestClass?: string;
  entryDate?: string;
}

export interface BulkAddPartnersResultDto {
  created: number;
  totalOwnership: number;
  remainingCapacity: number;
}

export interface UpdateOwnershipDto {
  ownershipPercent: number;
  interestClass?: string;
}

export interface ExitPartnerResultDto {
  exitDate: string;
  partnerId: number;
  partnerName: string;
}

export interface PartnershipByClassDto {
  class: string;
  count: number;
  totalPercent: number;
}

export interface PartnershipSummaryDto {
  partnershipId: number;
  partnershipName: string;
  totalOwnership: number;
  remainingCapacity: number;
  partnerCount: number;
  byClass: PartnershipByClassDto[];
  isFullySubscribed: boolean;
}

export interface TierStructureItemDto {
  partnerId: number;
  partnerName: string;
  tierLevel: number;
  relationshipDirection: string;
}

export interface GenerateFromRosterResultDto {
  updated: number;
  tierStructure: TierStructureItemDto[];
}

export interface PartnerImportResultDto {
  created: number;
  entitiesCreated: number;
  skipped: string[];
  totalOwnership: number;
}

export const INTEREST_CLASSES = ['GP', 'Class A', 'Class B', 'Class C', 'Other'];
